import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mgfw-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {

  showheader = false;
  @Output() IsPageNotFound = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    // this.name = this.activeRoute.snapshot.queryParamMap.get('lang');
    this.activeRoute.queryParamMap.subscribe(queryParams => {
      // this.name = queryParams.get('paramName');
    });
  }

}
